import type { IxcTradereportingV1BlueSheetKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const TRADE_REPORTING_BLUE_SHEET_BASE_PATH = getResolvedPath('/clearing/compliance/reporting/blue-sheet');

export const getTradeReportingBluesheetPath: EntityPathBuilder<IxcTradereportingV1BlueSheetKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return TRADE_REPORTING_BLUE_SHEET_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.reportId) {
        return undefined;
      }

      return getResolvedPath(`${TRADE_REPORTING_BLUE_SHEET_BASE_PATH}/$reportId`, context.keys);
    }
  }
};

export function getTradeReportingBluesheetDetailPath(reportId: string | undefined) {
  if (!reportId) {
    return undefined;
  }

  return getTradeReportingBluesheetPath({ kind: 'detail', keys: { reportId } });
}
